export default __webpack_public_path__ + "static/media/C6.c92bc7d3.gif";